module.exports = __webpack_public_path__ + "img/ykefu.554b6a6f.png";